import {
  collection,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore"
import { complexRefv9 } from "src/services/complexServices"

const TYPES_ACC_BANK = ["Cuenta Bancaria", "Cuenta BancariaOculta"]
const isActiveAccount = account => account?.Activa !== false

const accountsRef = id => collection(complexRefv9(id), "cuentas")

export const getAccounts = async (id, { includeInactive = false } = {}) => {
  try {
    const snap = await getDocs(
      query(accountsRef(id), orderBy("TipoMetodo", "desc"))
    )
    const data = snap.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(account => includeInactive || isActiveAccount(account))
    return data
  } catch (error) {
    throw Error(error)
  }
}

export const getBankAccounts = async id => {
  try {
    const snap = await getDocs(
      query(accountsRef(id), where("TipoMetodo", "in", TYPES_ACC_BANK))
    )
    const data = snap.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(isActiveAccount)
    return data
  } catch (error) {
    return []
  }
}

export const suscriberBankAccounts = (id, observer) =>
  onSnapshot(
    query(
      accountsRef(id),
      where("TipoMetodo", "in", TYPES_ACC_BANK),
      orderBy("TipoMetodo", "desc")
    ),
    observer
  )
